import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomeComponent } from './components/portal/pages/home/home.component';
import { ProfileComponent } from './components/portal/pages/profile/profile.component';
import { SubmissionsComponent } from './components/portal/pages/submissions/submissions.component';
import { UserProfileComponent } from './components/portal/pages/user-profile/user-profile.component';
import { MsalGuard } from '@azure/msal-angular';
import { MsalRedirectComponent } from '@azure/msal-angular';
import { EnrollmentComponent } from './components/portal/pages/enrollment/enrollment/enrollment.component';
import { IncomeInfoComponent } from './components/portal/pages/enrollment/income-info/income-info.component';
import { InsuranceInfoComponent } from './components/portal/pages/enrollment/insurance-info/insurance-info.component';
import { PatientInfoComponent } from './components/portal/pages/enrollment/patient-info/patient-info.component';
import { PhysicianInfoComponent } from './components/portal/pages/enrollment/physician-info/physician-info.component';
import { ReviewInfoComponent } from './components/portal/pages/enrollment/review-info/review-info.component';
import { SignaturesComponent } from './components/portal/pages/enrollment/signatures/signatures.component';
import { AccountDetailsResolver } from '../services/account-details.resolver';

const enrollmentRoutes: Routes = [
  { path: 'Profile', component: PatientInfoComponent },
  { path: 'Income', component: IncomeInfoComponent },
  { path: 'Insurance', component: InsuranceInfoComponent },
  { path: 'Physician', component: PhysicianInfoComponent },
  { path: 'Review', component: ReviewInfoComponent },
  { path: 'Signatures', component: SignaturesComponent },
];

const routes: Routes = [
  {
    path: 'redirect',
    component: MsalRedirectComponent,
    canActivate: [MsalGuard]
  },  
  {
    path: 'home',
    component: HomeComponent,
    canActivate: [MsalGuard],
    resolve: { accountDetails: AccountDetailsResolver }
  },
  {
    path: 'profile',
    component: ProfileComponent,
    canActivate: [MsalGuard],
    resolve: { accountDetails: AccountDetailsResolver }
  },
  {
    path: 'submissions',
    component: SubmissionsComponent,
    canActivate: [MsalGuard],
    resolve: { accountDetails: AccountDetailsResolver }
  },
  {
    path: 'userProfile',
    component: UserProfileComponent,
    canActivate: [MsalGuard]
  },
  // {
  //   path: 'enrollment',
  //   component: EnrollmentComponent,
  //   loadChildren: () => import('./components/portal/pages/enrollment/enrollment.module').then(m => m.EnrollmentModule)
  // },
  {
    path: 'enrollment',
    component: EnrollmentComponent,
    children: enrollmentRoutes,
  },
  {
    path: 'enrollment/:id',
    component: EnrollmentComponent,
    children: enrollmentRoutes,
  },
  { path: '', redirectTo: '/home', pathMatch: 'full' },
  { path: '**', redirectTo: '/home' }
  
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: false, paramsInheritanceStrategy: 'always', scrollPositionRestoration: "top" })], 
  exports: [RouterModule] 
})
export class AppRoutingModule { }
